import React from "react";
import _ from "lodash";
import { withTranslation } from "react-i18next";
import UnitInput from "../../parts/inputs/unit-input";
import { RillContext } from "../../rill/RillReact/share/base";

class View extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.state = {
      units: "metric",
    };
  }

  handleUnitsChange(to) {
    this.setState({ units: to });
    this.props.locals.units = to;
  }

  render() {
    const { t } = this.props;
    const { locals } = this.context;
    const { activeUser, momentTZ } = locals;

    const thisYear = momentTZ().year();
    const [first_name, last_name] = _.get(activeUser, "name", " ").split(/ +/);
    return (
      <div id="login-wrapper">
        <form action="/dashboard/settings/profile" method="POST" data-noreset>
          <input
            type="hidden"
            name="redirect"
            value="/dashboard/calendar?firstLogin=true"
          />
          <input type="hidden" name="first_name" value={first_name} />
          <input type="hidden" name="last_name" value={last_name} />
          <input type="hidden" name="setup" value="finished" />
          <input type="hidden" name="firstLogin" value="true" />

          <img
            className="logo"
            src="/img/msb-logo-white.svg"
            alt={t("step3.logoAlt")}
          />

          <div className="Steps" data-step="4">
            <div className="step" />
            <div className="step" />
            <div className="step" />
            <div className="step" />
          </div>

          <div className="frame">
            <div className="head">
              <h1 className="alt">{t("step3.title")}</h1>
              <p>{t("step3.description")}</p>
            </div>

            <div className="columns">
              <div className="column" data-col="1/2">
                <div className="label">
                  {t("step3.dateOfBirth")}{" "}
                  <span className="required-input">*</span>
                </div>
                <select
                  required
                  name="birthday[month]"
                  className="select-input"
                  defaultValue=""
                >
                  <option disabled hidden value="">
                    {t("step3.month")}
                  </option>
                  {_.map(_.range(1, 13), (month) => {
                    return (
                      <option key={month} value={month}>
                        {momentTZ(month, "M").format("MMMM")}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="column" data-col="1/4">
                <div className="label hide-responsive">&nbsp;</div>
                <select
                  required
                  name="birthday[day]"
                  className="select-input"
                  defaultValue=""
                >
                  <option disabled hidden value="">
                    {t("step3.day")}
                  </option>
                  {_.map(_.range(1, 32), (day) => {
                    return (
                      <option key={day} value={day}>
                        {day}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="column" data-col="1/4">
                <div className="label hide-responsive">&nbsp;</div>
                <select
                  required
                  name="birthday[year]"
                  className="select-input"
                  defaultValue=""
                >
                  <option disabled hidden value="">
                    {t("step3.year")}
                  </option>
                  {_.map(
                    _.range(
                      momentTZ().subtract(100, "years").year(),
                      momentTZ().subtract(10, "years").year()
                    ),
                    (year) => {
                      return (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      );
                    }
                  ).reverse()}
                </select>
              </div>

              <div className="column" data-col="1/2">
                <div className="label">
                  {t("step3.gender")}{" "}
                  <span className="required-input">*</span>
                </div>
                <select
                  required
                  name="gender"
                  className="select-input"
                  defaultValue=""
                >
                  <option disabled hidden value="">
                    {t("step3.gender")}
                  </option>
                  <option value="male">{t("step3.male")}</option>
                  <option value="female">{t("step3.female")}</option>
                </select>
              </div>

              <hr />

              <div className="column" data-col="1/1">
                <div className="label radio-label">
                  {t("step3.preferredMeasurement")}
                </div>
                <label className="radio-input">
                  <input
                    type="radio"
                    name="units"
                    defaultChecked
                    onClick={() => this.handleUnitsChange("metric")}
                    defaultValue="metric"
                  />
                  <span className="radio" />
                  <span className="text">{t("step3.metricKg")}</span>
                </label>
                <label className="radio-input">
                  <input
                    type="radio"
                    name="units"
                    onClick={() => this.handleUnitsChange("imperial")}
                    defaultValue="imperial"
                  />
                  <span className="radio" />
                  <span className="text">{t("step3.imperialLbs")}</span>
                </label>
              </div>

              <div className="column" data-col="1/1">
                <div className="label radio-label">
                  {t("step3.defaultLoadingParameter")}
                </div>
                <label className="radio-input">
                  <input
                    type="radio"
                    name="preferredLoadInput"
                    defaultChecked
                    defaultValue="percent"
                  />
                  <span className="radio" />
                  <span className="text">{t("step3.percentOf1rm")}</span>
                </label>
                <label className="radio-input">
                  <input
                    type="radio"
                    name="preferredLoadInput"
                    defaultValue="weight"
                  />
                  <span className="radio" />
                  <span className="text">{t("step3.weight")}</span>
                </label>
              </div>
            </div>

            <hr className="hr-no-columns" />

            <div className="column" data-col="1/1">
              <div className="label" style={{ marginBottom: "-20px" }}>
                {t("step3.repMaximum")}
              </div>
            </div>

            <div className="column" data-col="1/3">
              <div className="movement-label squat-color">
                {t("step3.squat1rm")}
              </div>
              <UnitInput
                required
                min="1"
                metric="kg"
                imperial="lb"
                units={this.state.units}
                className="text-input"
                name="repMaximums[squat]"
                placeholder=""
              />
            </div>

            <div className="column" data-col="1/3">
              <div className="movement-label bench-color">
                {t("step3.bench1rm")}
              </div>
              <UnitInput
                required
                min="1"
                metric="kg"
                units={this.state.units}
                imperial="lb"
                className="text-input"
                name="repMaximums[bench]"
                placeholder=""
              />
            </div>

            <div className="column" data-col="1/3">
              <div className="movement-label deadlift-color">
                {t("step3.deadlift1rm")}
              </div>
              <UnitInput
                required
                min="1"
                metric="kg"
                imperial="lb"
                units={this.state.units}
                className="text-input"
                name="repMaximums[deadlift]"
                placeholder=""
              />
            </div>

            <div className="column" data-col="1/2">
              <div className="label">
                {t("step3.bodyWeight")}{" "}
                <span className="required-input">*</span>
              </div>
              <UnitInput
                required
                metric="kg"
                imperial="lb"
                className="text-input"
                name="weight"
                min="1"
                placeholder={t("step3.bodyWeightPlaceholder")}
                units={this.state.units}
              />
            </div>

            <hr className="hr-no-columns" />

            <div className="foot">
              <button className="button-input full" type="submit">
                {t("step3.getStarted")}
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

View.contextType = RillContext;

const TranslatedView = withTranslation("auth")(View);

const Step3 = (app) => {
  app.get("/step3", ({ res, locals }, next) => {
    res.body = <TranslatedView locals={locals} />;
  });
};

export default Step3;
